// extracted by mini-css-extract-plugin
export default {"toolboxContainer":"jZtEdO","toolboxActions":"O_Apss","toolboxAction":"Rcn20I"};